<template>
  <a-card :bordered='false'>

    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='12'>
          <a-col :md='8' :sm='8'>
            <a-form-item label='盘号' :labelCol='{span: 8}' :wrapperCol='{span: 14, offset: 1}'>
              <a-select allowClear placeholder='请选择盘号' v-model='queryParam.appSsid'>
                <a-select-option v-for='item in appList' :value='item.appssid' :key='item.appssid'>{{ item.appName }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='8' :sm='8'>
            <a-form-item label='第三方' :labelCol='{span: 8}' :wrapperCol='{span: 14, offset: 1}'>
              <a-select allowClear placeholder='请选择第三方' v-model='queryParam.thirdParty'>
                <a-select-option v-for='item in thirdList' :value='item.thirdParty' :key='item.id'>{{ item.thirdName || item.thirdParty }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='8' :sm='8'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>查询</a-button>
              <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>

      <div class='table-operator' style='border-top: 5px'>
        <a-button @click='handleAdd' type='primary' icon='plus'>添加</a-button>
      </div>

      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='ipagination'
        :loading='loading'
        :rowClassName='rowClassName'
        bordered
        @change='handleTableChange'>
        <a-tag slot='status' slot-scope='text' :color="text === 1 ? 'green' : 'red'">{{ text === 1 ? '启用' : '关闭' }}</a-tag>
        <span slot='action' slot-scope='text, record'>
          <a @click='handleEdit(record)'>
            <a-icon type='edit' />
            编辑
          </a>
          <template v-if='!isFallbackRow(record)'>
            <a-divider type='vertical' />
            <a-popconfirm title='确定删除吗?' @confirm='() => handleDelete(record.id)'>
              <a>删除</a>
            </a-popconfirm>
          </template>
        </span>
      </a-table>

    </div>
    <app-third-modal ref='modalForm' @ok='modalFormOk'></app-third-modal>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import moment from 'moment'
import { getAppThirdList, deleteAppThird, getThirdAll } from '@/webpublicapi/third'
import { getApplistExcludingSubApp } from '@/webpublicapi/order'
import AppThirdModal from './modules/AppThirdModal'

export default {
  name: 'AppThird',
  components: { AppThirdModal },
  data() {
    return {
      dataSource: [],
      loading: false,
      appList: [],
      thirdList: [],
      // 查询条件
      queryParam: {
        appSsid: undefined,
        thirdParty: undefined
      },
      // 分页参数
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      // 表头
      columns: [
        {
          title: '盘号',
          align: 'left',
          dataIndex: 'appSsid'
        },
        {
          title: '第三方',
          align: 'left',
          dataIndex: 'thirdParty',
          customRender: (text, record) => record.thirdName || text
        },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '更新时间',
          align: 'center',
          dataIndex: 'updatedTime',
          customRender: (text) => this.formatDateTime(text)
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created() {
    this.loadData(1)
    this.loadAppList()
    this.loadThirdList()
  },
  methods: {
    // 更新时间：时间戳(秒/毫秒)转年月日时分秒，日期字符串原样
    formatDateTime(text) {
      if (text === null || text === undefined || text === '') {
        return ''
      }
      const value = String(text)
      if (/^\d+$/.test(value)) {
        const time = value.length <= 10 ? Number(value) * 1000 : Number(value)
        return moment(time).format('YYYY-MM-DD HH:mm:ss')
      }
      return text
    },
    // 盘号为0(全盘号兜底)的配置不允许删除，操作列不展示删除按钮
    isFallbackRow(record) {
      return record.appSsid === '0'
    },
    // 全局兜底行整行底色提示
    rowClassName(record) {
      return this.isFallbackRow(record) ? 'global-fallback-row' : ''
    },
    loadAppList() {
      getApplistExcludingSubApp().then(res => {
        if (res.code === 1000) {
          // 过滤"全部"空值项，前插 '0' 兜底项（本表 '0' 为合法配置：全盘号）
          this.appList = [{ appssid: '0', appName: '0-全部盘号' }]
            .concat((res.data || []).filter(item => item.appssid !== ''))
        }
      })
    },
    loadThirdList() {
      getThirdAll().then(res => {
        if (res.code === 1000) {
          this.thirdList = res.data
        }
      })
    },
    searchQuery() {
      this.loadData(1)
    },
    loadData(arg) {
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }
      this.loading = true
      var params = this.getQueryParams()
      getAppThirdList(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          this.ipagination.total = res.data.total
          this.dataSource = res.data.rows
        } else {
          this.ipagination.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    getQueryParams() {
      var param = Object.assign({}, this.queryParam)
      param.pageNum = this.ipagination.current
      param.pageSize = this.ipagination.pageSize
      return filterObj(param)
    },
    handleTableChange(pagination) {
      this.ipagination = pagination
      this.loadData()
    },
    handleAdd() {
      this.$refs.modalForm.add()
      this.$refs.modalForm.title = '新增'
    },
    handleEdit(record) {
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = '编辑'
    },
    handleDelete(id) {
      // 盘号为0的配置不允许删除（按钮已隐藏，此处防御性兜底）
      const record = this.dataSource.find(item => item.id === id)
      if (record && this.isFallbackRow(record)) {
        this.$message.warning('盘号为0的配置不允许删除')
        return
      }
      deleteAppThird({ id }).then((res) => {
        if (res.code === 1000) {
          this.$message.success(res.msg)
          this.loadData()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    // 重置
    searchReset() {
      this.queryParam = {
        appSsid: undefined,
        thirdParty: undefined
      }
      this.loadData(1)
    },
    // model回调
    modalFormOk() {
      this.loadData()
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";

/deep/ .global-fallback-row td {
  background: #F0FFF0;
}
</style>
